import { useState, useEffect } from 'react';
import { listProductSets } from "../actions/productSetAction";
import axios from 'axios';
import Slider from "react-slick";
import Message from "./Message";
import Loader from "./Loader";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { serverIp } from "../config/conf";
import { Carousel } from "react-responsive-carousel";
import { listSizes } from "../actions/sizeActions";
import { addItemToCart } from "../actions/cartActions";
import CartDrawer from "./CartDrawer";
import WishlistToggleButton from "./WishlistButton";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";


import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
    getWishlistItems,
    removeItemFromWishlist,
} from "../actions/wishListActions";
import {
    useDisclosure,
} from "@chakra-ui/react";
import { FaShoppingCart } from "react-icons/fa";


function ProductSlider({
    title,
    queryUrl,
    // labelText = '',
    // labelClassName = '',
    isTopPad,
    isBgColor,
    bannerCategory = null, // optional banner category
}) {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const wishList = useSelector((state) => state.wishlist);
    const { wishlistItems, successRemove, successAdd } = wishList;

    const productSetList = useSelector((state) => state.productSetList);
    const { loading, error, productSets } = productSetList;

    const sizeList = useSelector((state) => state.sizeList);
    const { loading: loadingSize, error: errorSize, sizes } = sizeList;


    const [products, setProducts] = useState([]);
    const [productLoading, setProductLoading] = useState(false);
    const [productError, setProductError] = useState(null);

    const [banners, setBanners] = useState([]);
    const [bannerLoading, setBannerLoading] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    const [qty, setQty] = useState(1);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [isBuyNow, setIsBuyNow] = useState(false);
    const [engravingTextMen, setEngravingTextMen] = useState("");
    const [engravingTextWomen, setEngravingTextWomen] = useState("");
    const [selectedPlating, setSelectedPlating] = useState([]);
    const [selectedSizeMen, setSelectedSizeMen] = useState("");
    const [selectedSizeWomen, setSelectedSizeWomen] = useState("");
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [productSet, setProductSet] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemBasePrice, setSelectedItemBasePrice] = useState([]);
    const [allowRingSize, setAllowRingSize] = useState(false);

    const [allowAnkletType, setAllowAnkletType] = useState(false);
    const [allowBraceletSize, setAllowBraceletSize] = useState(false);
    const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState("");
    const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] =
        useState("");
    const [isPair, setIsPair] = useState(false);

    const [selectedAnkletSize, setSelectedAnkletSize] = useState("");


    //********** For Pet *************//

    const [frontPetTexts, setFrontPetTexts] = useState([]);
    const [petTypesSelected, setPetTypesSelected] = useState([]);
    const [backPetTexts, setBackPetTexts] = useState([]);
    const [breedAge, setBreedAge] = useState([]);
    const [breedSize, setBreedSize] = useState([]);

    const handlePetFrontEngChange = (text, index) => {
        const updated = [...frontPetTexts];
        updated[index] = text;
        setFrontPetTexts(updated);
    };

    const handlePetTypeChange = (pet, index) => {
        const updated = [...petTypesSelected];
        updated[index] = pet;
        setPetTypesSelected(updated);
    };

    const handlePetBackEngChange = (text, index) => {
        const updated = [...backPetTexts];
        updated[index] = text;
        setBackPetTexts(updated);
    };

    const handleBreedAgeChange = (text, index) => {
        const updated = [...breedAge];
        updated[index] = text;
        setBreedAge(updated);
    };

    const handleBreedSizeChange = (text, index) => {
        const updated = [...breedSize];
        updated[index] = text;
        setBreedSize(updated);
    };

    useEffect(() => {
        // console.log("selectedProduct", selectedProduct);
        if (
            selectedProduct
            &&
            selectedProduct.productCollections?.some(cat => cat.name === "Pet Collection") &&
            selectedProduct.canEngrave && selectedProduct.canBackEng
        ) {
            const q = qty || 1;

            console.log("In Pet Collection Collection");

            setFrontPetTexts(prev => {
                const updated = [...prev];
                while (updated.length < q) updated.push('');
                return updated.slice(0, q);
            });

            setPetTypesSelected(prev => {
                const updated = [...prev];
                while (updated.length < q) updated.push(null);
                return updated.slice(0, q);
            });

            setBackPetTexts(prev => {
                const updated = [...prev];
                while (updated.length < q) updated.push('');
                return updated.slice(0, q);
            });

            setBreedAge(prev => {
                const updated = [...prev];
                while (updated.length < q) updated.push('');
                return updated.slice(0, q);
            });

            setBreedSize(prev => {
                const updated = [...prev];
                while (updated.length < q) updated.push('');
                return updated.slice(0, q);
            });
        }
    }, [qty]);


    useEffect(() => {
        dispatch(listProductSets());
        dispatch(listSizes());
    }, [dispatch]);

    const sliderSettings = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        nextArrow: <MdNavigateNext className="text-gray-500 w-8 h-8" />,
        prevArrow: <MdNavigateBefore className="text-gray-500 w-8 h-8" />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 600, settings: { slidesToShow: 2 } },
        ],
    };

    const carouselConfig = {
        showArrows: true,
        showIndicators: banners.length > 1,
        infiniteLoop: true,
        autoPlay: true,
        stopOnHover: true,
        interval: 4000,
        transitionTime: 900,
        showThumbs: false,
        dynamicHeight: false,
        showStatus: false,
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setProductLoading(true);
                const res = await axios.get(`${serverIp}/api/products?${queryUrl}`);
                setProducts(res.data.products);
            } catch (err) {
                const message = err?.response?.data?.message || 'Failed to load products.';
                setProductError(message);
            } finally {
                setProductLoading(false);
            }
        };
        fetchProducts();
    }, [queryUrl]);


    useEffect(() => {
        if (!bannerCategory) return;

        const fetchBanners = async () => {
            try {
                setBannerLoading(true);
                const res = await axios.get(`${serverIp}/api/hero?country=india&category=${bannerCategory}`);
                setBanners(res.data.heros || []);
            } catch (err) {
                console.error("Failed to load banners:", err);
            } finally {
                setBannerLoading(false);
            }
        };

        fetchBanners();

        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [bannerCategory]);

    useEffect(() => {
        if (wishlistItems && wishlistItems?.length > 0) {
            if (wishlistItems?.some((item) => !item._id)) {
                dispatch(getWishlistItems());
            }
        }
    }, [wishlistItems]);

    const notify = (link, content, type) =>
        type(<RouterLink to={link}>{content}</RouterLink>);


    const handleAccordionToggle = (isOpen) => {
        setIsAccordionOpen(isOpen); // Toggle Accordion state
        if (!isOpen) {
            setEngravingTextMen(""); // Clear engraving text when Accordion is closed
            setEngravingTextWomen(""); // Clear engraving text when Accordion is closed
        }
    };

    const handleQuantityChange = (value) => {
        if (value >= 1 && value <= 5) {
            setQty(value);
        }
    };

    const handleEngravingInput = (value, gender) => {
        const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
        if (lettersAndSpaces.test(value)) {
            if (gender === "female" || gender === "unisex") {
                setEngravingTextWomen(value); // Update engraving text if input is valid
            } else {
                setEngravingTextMen(value); // Update engraving text if input is valid
            }
        }
    };


    const handleAddToCart = (obj) => {
        // e.preventDefault();
        const addToCart = () => {

            if (userInfo) {

                dispatch(addItemToCart(obj));

                // Check if the item exists in the wishlist
                const isInWishlist = wishlistItems?.some((item) => item._id === obj.product);

                if (isInWishlist) {
                    dispatch(removeItemFromWishlist(obj.product));
                }

                onClose();
                if (isBuyNow) {
                    setIsBuyNow(false);
                    navigate("/cart");
                } else {
                    notify("/cart", "Item Added To Cart", toast.success);
                }
            } else {
                onClose();
                // Guest user – store in localStorage
                const savedCart = JSON.parse(localStorage.getItem("savedCart")) || [];

                const existingItem = savedCart.find(item => item.product === obj.product);

                if (!existingItem) {
                    savedCart.push(obj);
                    localStorage.setItem("savedCart", JSON.stringify(savedCart));
                    toast.success("Item saved to cart (login to sync)");
                    window.dispatchEvent(new Event("localCartUpdated"));
                    // console.log("Cart Data ---->", savedCart);
                } else {
                    toast.info("Item already in cart");
                }
            }

        };

        const categories = selectedProduct.categories?.map(c => c.name?.toLowerCase()) || [];
        const subcategories = selectedProduct.subcategories?.map(s => s.name?.toLowerCase()) || [];

        const isListString = (list) => {
            return Array.isArray(list) && list.every(item => typeof item === 'string');
        };

        const isRings = categories.includes("rings");
        const isBracelets = categories.includes("bracelets");
        const isAnklets = categories.includes("anklets");
        const isCoupleRing = subcategories.includes("couple rings");
        const isCoupleBracelets = subcategories.includes("for couples");
        const isSets = categories.includes("jewellery sets");
        const isMale = selectedProduct.gender?.toLowerCase() === "male";


        if (isSets && productSet.length > 0 && productSet.length < 2) {
            notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
            return;
        }

        if (isRings && isCoupleRing && (selectedSizeMen === "" || selectedSizeWomen === "")) {
            notify("#", "Select Both Ring Size", toast.error);
            return;
        }

        if (isRings && isMale && selectedSizeMen === "") {
            notify("#", "Select Ring Size", toast.error);
            return;
        }

        if ((isRings ||
            (isSets && productSet.length === 0) ||
            (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
        ) && !isMale && selectedSizeWomen === "") {
            notify("#", "Select Ring Size", toast.error);
            return;
        }

        if (
            (isAnklets ||
                (isSets && productSet.length === 0 &&
                    !isListString(selectedProductDetails) &&
                    selectedProduct.products?.some(e => e.sku?.includes("SAIA"))) ||
                (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
            ) && selectedAnkletSize === ""
        ) {
            notify("#", "Select Anklet Size", toast.error);
            return;
        }

        if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
            notify("#", "Select Both Bracelets Size", toast.error);
            return false;
        }

        if (isBracelets && isMale && selectedBraceletSizeMen === "") {
            notify("#", "Select Bracelets Size", toast.error);
            return false;
        }

        if (
            (isBracelets ||
                (isSets && productSet.length === 0 &&
                    !isListString(selectedProductDetails) &&
                    selectedProduct.products?.some(e => e.sku?.includes("SAIB"))) ||
                (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
            ) && !isMale && selectedBraceletSizeWomen === ""
        ) {
            notify("#", "Select Bracelets Size", toast.error);
            return false;
        }

        if (selectedProduct.canImgEng && selectedProduct.canBackEng) {
            if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
                notify("#", "Please Select Breed", toast.error);
                return;
            }

            if (breedSize.includes('')) {
                notify("#", "Please Select Size", toast.error);
                return;
            }

            if (breedAge.includes('')) {
                notify("#", "Please Select Your Pet Age", toast.error);
                return;
            }

            if (frontPetTexts.includes('')) {
                notify("#", "Enter Front Engraving Characters", toast.error);
                return;
            }

            if (backPetTexts.includes('')) {
                notify("#", "Enter Back Engraving Characters", toast.error);
                return;
            }
        }

        // All validations passed — add to cart
        addToCart();

    };


    const totalPrice = selectedItems.reduce((sum, price) => sum + price, 0);

    const totalBasePrice = selectedItemBasePrice.reduce(
        (sum, price) => sum + price,
        0
    );


    const selectedProductDetails = {
        name: selectedProduct?.name,
        image:
            selectedProduct?.variants?.length > 0 &&
            selectedProduct?.variants?.filter((variant) =>
                selectedPlating.length > 0
                    ? selectedPlating.includes(variant.color)
                    : variant.isPrimary
            )[0]?.images[0],
        qty,
        sizeMen: selectedSizeMen,
        sizeWomen: selectedSizeWomen,
        price: productSet.length > 0 ? totalPrice : selectedProduct?.price,
        basePrice:
            productSet.length > 0 ? totalBasePrice : selectedProduct?.basePrice,

        product: selectedProduct?._id,
        products: productSet,
        variant:
            selectedProduct?.variants?.length > 0 &&
            selectedProduct?.variants?.filter((variant) => variant?.isPrimary)[0]
                ?._id,
        sku: selectedProduct?.sku,
        giftWrap: false,
        message: "",
        engraveMen: engravingTextMen,
        engraveWomen: engravingTextWomen,
        isPair: false,
        braceletsSizeMen:
            selectedBraceletSizeMen,
        braceletsSizeWomen:
            selectedBraceletSizeWomen,
        ankletsSize: selectedAnkletSize,
        petFrontEng: frontPetTexts,
        petBackEng: backPetTexts,
        petEngImage: petTypesSelected,
        breedAge: breedAge,
        breedSize: breedSize,
    };

    const uploadImageHandler = async (e, setImageCallback) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("image", file);
        // setUploading(true);

        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };

            const { data } = await axios.post(
                `${serverIp}/api/uploads/single`,
                formData,
                config
            );

            // Use the passed callback to set the image URL
            setImageCallback(data.file);

            // setUploading(false);
        } catch (err) {
            console.error(err);
            // setUploading(false);
        }
    };


    return (
        <>
            {bannerCategory && (
                <div className={`w-full ${isTopPad === "true" ? "pt-6" : ""}`}>
                    {bannerLoading ? (
                        <div className={`w-full ${windowWidth <= 768 ? "h-[260px]" : "min-h-[320px]"} bg-slate-200 animate-pulse`} />
                    ) : (
                        <Carousel {...carouselConfig}>
                            {banners.map((banner, idx) => (
                                <div key={idx}>
                                    <RouterLink to={banner.link} className="block h-full">
                                        <img
                                            src={windowWidth <= 768 ? banner.urlMobImg : banner.url}
                                            alt="banner"
                                            loading="lazy"
                                            className={`w-full ${windowWidth <= 768 ? 'h-[240px]' : 'min-h-[320px]'} object-cover`}
                                        />
                                    </RouterLink>
                                </div>
                            ))}
                        </Carousel>
                    )}
                </div>
            )}

            <div className={`${isBgColor === "true" ? "bg-[#F3F3FD]" : ""}`}>
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-6">
                    <p className={`text-center text-xl font-semibold ${isTopPad === "true" ? "pt-10" : "pt-6"} pb-6`}>{title}</p>
                    {productLoading ? (
                        <Loader />
                    ) : productError ? (
                        <Message type="error">{productError}</Message>
                    ) : (
                        <Slider {...sliderSettings}>
                            {products.map((prod, idx) => (
                                <ProductCard
                                    key={idx}
                                    prod={prod}
                                    setSelectedProduct={setSelectedProduct}
                                    onOpen={onOpen}
                                    setIsBuyNow={setIsBuyNow}
                                    navigate={navigate}
                                    userInfo={userInfo}
                                    windowWidth={windowWidth}
                                />
                            ))}
                        </Slider>
                    )}
                </div>
            </div>
            <CartDrawer
                isOpen={isOpen}
                onClose={onClose}
                isBuyNow={isBuyNow}
                selectedProductDetails={selectedProductDetails}
                handleAddToCart={handleAddToCart}
                qty={qty}
                handleQuantityChange={handleQuantityChange}
                selectedProduct={selectedProduct}
                productSet={productSet}
                setProductSet={setProductSet}
                selectedPlating={selectedPlating}
                sizes={sizes}
                loadingSize={loadingSize}
                errorSize={errorSize}
                selectedSizeMen={selectedSizeMen}
                setSelectedSizeMen={setSelectedSizeMen}
                selectedSizeWomen={selectedSizeWomen}
                setSelectedSizeWomen={setSelectedSizeWomen}
                selectedAnkletSize={selectedAnkletSize}
                setSelectedAnkletSize={setSelectedAnkletSize}
                isPair={isPair}
                setIsPair={setIsPair}
                selectedBraceletSizeMen={selectedBraceletSizeMen}
                setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
                selectedBraceletSizeWomen={selectedBraceletSizeWomen}
                setSelectedBraceletSizeWomen={setSelectedBraceletSizeWomen}
                allowRingSize={allowRingSize}
                setAllowRingSize={setAllowRingSize}
                allowBraceletSize={allowBraceletSize}
                setAllowBraceletSize={setAllowBraceletSize}
                allowAnkletType={allowAnkletType}
                setAllowAnkletType={setAllowAnkletType}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedItemBasePrice={selectedItemBasePrice}
                setSelectedItemBasePrice={setSelectedItemBasePrice}
                totalPrice={totalPrice}
                totalBasePrice={totalBasePrice}
                engravingTextMen={engravingTextMen}
                engravingTextWomen={engravingTextWomen}
                handleEngravingInput={handleEngravingInput}
                isAccordionOpen={isAccordionOpen}
                handleAccordionToggle={handleAccordionToggle}
                uploadImageHandler={uploadImageHandler}
                petTypesSelected={petTypesSelected}
                handlePetTypeChange={handlePetTypeChange}
                frontPetTexts={frontPetTexts}
                handlePetFrontEngChange={handlePetFrontEngChange}
                backPetTexts={backPetTexts}
                handlePetBackEngChange={handlePetBackEngChange}
                breedAge={breedAge}
                handleBreedAgeChange={handleBreedAgeChange}
                breedSize={breedSize}
                handleBreedSizeChange={handleBreedSizeChange}
            />
        </>
    );
}



function ProductCard({ prod, key, setSelectedProduct, onOpen, setIsBuyNow, navigate, userInfo, windowWidth }) {

    const primaryVariant = prod?.variants?.find((v) => v.isPrimary);

    return <div key={key} className="px-2 py-2 max-w-[240px]">
        <div className="relative bg-white rounded-lg border-2 border-gray-200 shadow overflow-visible transition-transform hover:scale-105 duration-300">

            {/* 🔖 HALLMARKED Badge */}
            <div className="absolute top-2 left-2 bg-[#000080] text-white text-[9px] md:text-[11px] font-semibold px-2 md:px-3 py-[2px] rounded shadow z-10 whitespace-nowrap">
                HALLMARKED
            </div>

            {/* ❤️ Wishlist Icon */}

            <WishlistToggleButton product={prod} />


            {/* 🔗 Product Image */}
            <RouterLink
                className="block"
                to={`/product/${prod.name?.replaceAll(" ", "-")}/${prod._id}?variant=${primaryVariant?._id}`}
            >
                <img
                    src={primaryVariant?.images[0]}
                    loading="lazy"
                    alt={prod.name}
                    // className="aspect-1 w-full max-w-[226px] max-h-[226px] object-cover rounded-lg"
                    className="aspect-1 w-full object-cover rounded-lg"
                />
            </RouterLink>

            {/* 📝 Product Info */}
            <div className="p-3 pt-0">

                <p className="font-medium text-sm md:text-[14px] truncate whitespace-nowrap overflow-hidden text-ellipsis text-left">
                    {prod.name}
                </p>

                <div className="flex flex-wrap md:flex-nowrap gap-1 md:gap-2 items-end">

                    {/* 🔻 Base Price (Strikethrough) */}
                    <p
                        className={`inline-block p-1 text-[14px] line-through text-gray-400 ${prod.basePrice === 0 ? "hidden" : ""}`}
                    >
                        ₹ {Math.round(prod.basePrice)?.toLocaleString("en-IN")}
                    </p>

                    {/* 📉 Discount */}
                    <p
                        className={`${prod.discountedPercent === 0 ? "hidden" : ""} inline-block text-[13px] text-[#000080]`}
                    >
                        -{(((prod.basePrice - prod.price) / prod.basePrice) * 100)?.toFixed(0)}%
                    </p>
                </div>

                {/* 💰 Price */}
                <p className="inline-block text-[15px] font-semibold text-black text-left">
                    ₹ {Math.round(prod.price)?.toLocaleString("en-IN")}
                </p>


                <div className="mt-2 flex justify-center gap-2">
                    <button
                        className="flex items-center justify-center w-full px-4 py-2 text-[12px] font-medium text-white bg-[#000080] rounded border border-transparent hover:bg-white hover:text-[#000080] hover:border-[#000080] transition-colors duration-200"
                        onClick={() => {
                            // if (userInfo?.firstName) {
                            setIsBuyNow(false);
                            onOpen();
                            setSelectedProduct(prod);
                            // } else {
                            //     const primaryVariantId =
                            //         prod?.variants?.find((variant) => variant.isPrimary)?._id || "";

                            //     const productSlug = prod.name?.replaceAll(" ", "-");

                            //     navigate(`/signup?redirect=/product/${productSlug}/${prod._id}?variant=${primaryVariantId}`);
                            // }
                        }}
                    >
                        {/* {windowWidth <= 1024 ? (
                                                        <> */}
                        <FaShoppingCart className="inline mr-1" />
                        {windowWidth <= 780 ? null : "CART"}
                        {/* </>
                                                    ) : (
                                                        "ADD TO CART"
                                                    )} */}

                    </button>
                    <button
                        className="w-full px-4 py-2 text-[12px] font-medium text-[#000080] border border-[#000080] bg-white rounded hover:bg-[#000080] hover:text-white transition-colors duration-200"
                        onClick={() => {
                            if (userInfo?.firstName) {
                                onOpen();
                                setSelectedProduct(prod);
                                setIsBuyNow(true);
                            } else {
                                const primaryVariantId =
                                    prod?.variants?.find((variant) => variant.isPrimary)?._id || "";

                                const productSlug = prod.name?.replaceAll(" ", "-");

                                navigate(`/signup?redirect=/product/${productSlug}/${prod._id}?variant=${primaryVariantId}`);
                            }
                        }}
                    >
                        BUY
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export { ProductSlider, ProductCard };
